function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffdf43;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Trazado_95",
  "data-name": "Trazado 95",
  className: "cls-1",
  d: "M9.987.791l2.128,4.256c.164.164.327.491.655.491l4.748.655a.9.9,0,0,1,.491,1.473l-3.438,3.274a1.251,1.251,0,0,0-.327.819l.819,4.748a.781.781,0,0,1-1.146.819L9.66,15.034a.731.731,0,0,0-.819,0L4.585,17.326a.757.757,0,0,1-1.146-.819l.819-4.748c0-.327,0-.491-.164-.655L.492,7.667A.879.879,0,0,1,.983,6.194l4.748-.655c.327,0,.491-.164.655-.491L8.514.791A.8.8,0,0,1,9.987.791Z",
  transform: "translate(-0.256 -0.3)"
});

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.99,
    height: 17.13,
    viewBox: "0 0 17.99 17.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.77edaad4.svg";
export { ForwardRef as ReactComponent };